export default {
  title: 'Verify it`s you.',
  subTitle: ' We`ve sent a verification code to your email.\nEnter the code from the email in the field below.',
  form: {
    fields :{
      code: {
        label: 'Enter 6 digit code',
      },
    },
    btnSubmit: 'Verify',
  }
};
